import { ChangeEvent, HTMLAttributes } from 'react';
import errorIcon from '../../assets/icons/error.svg';
import { borderStyleConstants } from '../../constants/borderStyle';
import { useWidth } from '../../hooks/useWidth';
import { useSafeSelector } from '../../hooks/useSafeSelector';
export interface FormInputProps {
  placeholder?: string;
  label?: false | string | JSX.Element;
  type?: string;
  maxLength?: number;
  name: string;
  error?: any;
  className?: string;
  borderStyle?: string;
  customInputStyle?: string;
  inputMode?: HTMLAttributes<HTMLElement>['inputMode'];
  icon?: any;
  formRegister: any;
  disabled?: boolean;
  customStyle?: any;
  borderRadius?: any;
  pattern?: string;
  value?: any;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  autoFocus?: boolean;
  verified?: boolean;
  autoComplete?: string;
}

export function FormInput(props: FormInputProps) {
  const {
    formRegister,
    icon,
    name,
    placeholder,
    label,
    error,
    maxLength,
    type,
    className,
    inputMode,
    disabled,
    pattern,
    customInputStyle,
    customStyle,
    value,
    onChange,
    autoFocus,
    borderStyle,
    verified,
    autoComplete
  } = props;

  const isMobile = useWidth();
  const { borderStyle: borderStyleState = borderStyle } = useSafeSelector(
    (state: any) => state.customization
  );

  return (
    <div className="flex flex-col w-full">
      <div
        className={`bg-white box-border px-3 border border-solid ${
          borderStyleState === borderStyleConstants.RECTANGULAR && '!rounded-none'
        } flex justify-between gap-2 items-center w-full h-10 opacity-100 relative ${
          className ?? ''
        }`}
        style={customStyle?.input ? customStyle?.input : customStyle}
      >
        {icon && icon}
        <input
          dir="ltr"
          id={name}
          name={name}
          type={type}
          className={`py-3 ${customStyle?.direction === 'rtl' ? 'text-right pl-4' : 'text-left pr-4'} bg-transparent h-full w-full border-0 box-border text-inherit focus:outline-none focus-visible:outline-none ${
            customInputStyle ?? ''
          } [&::placeholder]:text-[var(--placeholder-color)]`}
          style={{'--placeholder-color': customStyle?.placeholder?.color || '#667085', direction: 'ltr'}}
          value={value}
          onChange={onChange}
          autoFocus={autoFocus}
          {...formRegister}
          pattern={pattern}
          placeholder={placeholder ? placeholder : ''}
          maxLength={maxLength}
          autoComplete={autoComplete || 'off'}
          inputMode={inputMode}
          disabled={disabled}
        />
        {verified && (
          <span
            className="bg-[#E6FEEE] text-[#69BE76] font-Montserrat font-black rounded-sm text-[10px] leading-[10px] -tracing-[.2px] px-1 py-0.5
"
          >
            Verified
          </span>
        )}
        {!isMobile && label && (
          <label
            className="h-full w-1/3 flex items-center !justify-end"
            htmlFor={name}
          >
            {label}
          </label>
        )}
        {isMobile && label}
        {error && <img className="w-3 h-3" src={errorIcon} alt="error" />}
      </div>
    </div>
  );
}
